import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  palette: {
    type: "light",
  },
  section: {
    marginBottom: "0.5em",
    marginTop: "1em",
  },
  fullImage: {
    flex: 1,
    maxWidth: "100%",
    padding: "0.5em",
    marginBottom: "1em",
  },
  header: {
    flexDirection: "column",
    maxHeight: "30em",
  },
  headerImage: {
    alignSelf: "center",
    maxHeight: "25em",
    maxWidth: "60vw",
    display: "block",
    margin: "auto",
  },
  content: {
    maxWidth: "9in",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    padding: "32px",
  },
}));
